import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetServiceMetricsValuesResultType,
    GetServiceModulesColumnChartResultType,
    GetServiceModulesLineChartResultType,
    GetServiceModulesValuesResultType,
    ReportResultColumnDto,
    ServicesModulesClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceModulesService extends CustomReportServiceBase<ServicesModulesClient, CustomReportServiceView> {
    constructor(protected override client: ServicesModulesClient) {
        super(client);
    }

    async getValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceModulesValuesResultType[]> {
        return await lastValueFrom(this.client.servicesModulesGetServiceModulesValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.servicesModulesGetServiceModulesBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceModulesColumnChartResultType[]> {
        return await lastValueFrom(this.client.servicesModulesGetServiceModulesColumnChartValues(parameters));
    }

    async getMetricsValues(parameters: GetDataFilterValuesParameters): Promise<GetServiceMetricsValuesResultType> {
        return await lastValueFrom(this.client.servicesModulesGetServiceModulesMetricsValues(parameters));
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetServiceModulesLineChartResultType[]> {
        return await lastValueFrom(this.client.servicesModulesGetServiceModulesLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.servicesModulesSaveCatalogReport(body));
        return await lastValueFrom(this.client.servicesModulesSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.servicesModulesGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.servicesModulesCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.servicesModulesGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.servicesModulesResultAvailableColumns(organizationIds));
    }
}
